import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import client from "../../../app/core/client-http/client";
import { endpoint } from "../../../utils/constants/endpoint";
import { PURGE } from "redux-persist";

export const deleteDocument = createAsyncThunk(
  "singleDocument/delete",
  async (id, thunkAPI) => {
    const response = await client.delete(
      endpoint.ADMIN_DOCUMENT.DOCUMENTS + "/" + id
    );
    if (response.ok) {
      return thunkAPI.fulfillWithValue(response.data);
    } else {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const rejectDocument = createAsyncThunk(
  "singleDocument/reject",
  async (id, thunkAPI) => {
    const response = await client.delete(
      endpoint.ADMIN_DOCUMENT.DOCUMENTS + "/" + id + "/reject"
    );
    if (response.ok) {
      return thunkAPI.fulfillWithValue(response.data);
    } else {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const validateDocument = createAsyncThunk(
  "singleDocument/validate",
  async (body, thunkAPI) => {
    const response = await client.put(
      endpoint.ADMIN_DOCUMENT.DOCUMENTS + "/" + body.Id,
      body
    );
    if (response.ok) {
      return thunkAPI.fulfillWithValue(response.data);
    } else {
      return thunkAPI.rejectWithValue();
    }
  }
);

const _initialState = {
  isDocumentLoading: false,
  cu: [],
};

const singleDocumentSlice = createSlice({
  name: "singleDocumentSlice", // REDUX Storage name
  initialState: _initialState,
  reducers: {
    updateCuForm: (state, action) => {
      state.cu = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(validateDocument.fulfilled, (state, action) => {})
      .addCase(rejectDocument.fulfilled, (state, action) => {})
      .addCase(deleteDocument.fulfilled, (state, action) => {})
      .addCase(PURGE, (state) => {
        state = _initialState;
        return state;
      });
  },
});

export const { name, actions, reducer } = singleDocumentSlice;
